import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateStaffProfile } from '@services/registry';

export function useUpdateStaff({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ staffId, patch }) => {
            return await updateStaffProfile({ tenantId, staffId, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['staff', tenantId] });
        },
    });
}

